import { captureReferralAttributionFromLocation } from '~/utils/referralAttribution'

/**
 * Persist invite code from any landing URL (`?code=` / `?invite_code=`),
 * not only `/refer`, so register verify can send `invite_code`.
 */
export default defineNuxtPlugin({
  name: 'referral-attribution',
  setup() {
    const route = useRoute()

    watch(
      () => [route.fullPath, route.query.code, route.query.invite_code, route.query.ref],
      () => {
        captureReferralAttributionFromLocation(route.query)
      },
      { immediate: true },
    )
  },
})
